import * as THREE from 'three';
export class PlayerControls {
    constructor(camera, dom, options = {}) {
        this.eventTarget = new EventTarget();
        this.camera = camera;
        this.dom = dom;
        this.isMobile = !!options.isMobile;
        this.isLocked = this.isMobile;
        this.onPointerLockChange = () => {
            if (this.isMobile)
                return;
            const locked = document.pointerLockElement === this.dom;
            if (locked === this.isLocked)
                return;
            this.isLocked = locked;
            this.eventTarget.dispatchEvent(new Event(locked ? 'lock' : 'unlock'));
        };
        this.onPointerLockError = (event) => {
            if (this.isMobile)
                return;
            console.warn('[PlayerControls] Pointer lock error', event);
        };
        if (!this.isMobile) {
            document.addEventListener('pointerlockchange', this.onPointerLockChange);
            document.addEventListener('pointerlockerror', this.onPointerLockError);
        }
    }
    lock() {
        var _a, _b;
        if (this.isMobile) {
            this.isLocked = true;
            return;
        }
        (_b = (_a = this.dom).requestPointerLock) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    unlock() {
        var _a;
        if (this.isMobile) {
            this.isLocked = true;
            return;
        }
        (_a = document.exitPointerLock) === null || _a === void 0 ? void 0 : _a.call(document);
    }
    getObject() {
        return this.camera;
    }
    moveRight(distance) {
        const forward = new THREE.Vector3();
        this.camera.getWorldDirection(forward);
        forward.y = 0;
        forward.normalize();
        const right = new THREE.Vector3().crossVectors(forward, this.camera.up).normalize();
        this.camera.position.addScaledVector(right, distance);
    }
    moveForward(distance) {
        const dir = new THREE.Vector3();
        this.camera.getWorldDirection(dir);
        dir.y = 0;
        dir.normalize();
        this.camera.position.add(dir.multiplyScalar(distance));
    }
    addEventListener(type, listener) {
        this.eventTarget.addEventListener(type, listener);
    }
    removeEventListener(type, listener) {
        this.eventTarget.removeEventListener(type, listener);
    }
    dispose() {
        if (!this.isMobile) {
            document.removeEventListener('pointerlockchange', this.onPointerLockChange);
            document.removeEventListener('pointerlockerror', this.onPointerLockError);
        }
    }
}
